<div>
  <div class="data">{{data.message}}</div>
  <div class="dismiss">
    <button mat-icon-button (click)="update()" class="buttonHolder">
      <span class="buttonText">{{data.action}}</span>
      <mat-icon class="iconText">refresh</mat-icon>
    </button>
  </div>
</div>
